// Shared with LeaderboardPage.js and AnalysisPage.js so both show identical scores.
// Heuristic: accounts that have renewed (2+ subscriptions ever) score on renewal
// count alone; accounts that never renewed score on bot-activity engagement instead,
// capped lower since activity alone isn't proof of a renewal habit.
export function computeRenewalScores(accounts, subscriptions, requests, issues) {
  const subCountByAccount = {};
  subscriptions.forEach(s => { if (s.accountID) subCountByAccount[s.accountID] = (subCountByAccount[s.accountID] || 0) + 1; });

  const activityByDiscord = {};
  requests.forEach(r => { if (r.username) activityByDiscord[r.username] = (activityByDiscord[r.username] || 0) + 1; });
  issues.forEach(i => { if (i.memberUsername) activityByDiscord[i.memberUsername] = (activityByDiscord[i.memberUsername] || 0) + 1; });

  return accounts
    .map(a => {
      const subCount = subCountByAccount[a._id] || 0;
      const activityCount = (a.discord && activityByDiscord[a.discord]) || 0;
      const value = subCount > 1 ? Math.min(100, (subCount - 1) * 25) : Math.min(60, activityCount * 5);
      return { id: a._id, name: a.username, value, raw: { subCount, activityCount } };
    })
    .filter(e => e.value > 0)
    .sort((a, b) => b.value - a.value);
}
